import React from 'react';
import './LandingPage.css';
import RegisterInterestForm from '../components/RegisterInterestForm';
import Footer from '../components/Footer';

const LandingPage: React.FC = () => {
  return (
    <div className="landing-page">
      <div className="parallax parallax-1">
        <div className="parallax-content">
          <h1>Welcome to AIplify</h1>
          <p>Making fertility treatments easy and accessible.</p>
          {/* iOS App CTA */}
          <div className="ios-app-cta">
            <img
              src="/logo.ico"
              alt="Caelestis Fertility Logo"
              className="ios-app-logo"
            />
            <div className="ios-app-copy">
              <h3>Try the new Caelestis Fertility iOS app</h3>
              <div className="cta-buttons">
                <a
                  className="btn primary"
                  href="https://apps.apple.com/dk/app/caelestis-fertility/id6746871580"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  View on the App Store
                </a>
              </div>
            </div>
          </div>
          <div className="video-section">
            <p>Check out our demo</p>
            <div className="video-wrapper">
              <iframe
                src="https://www.youtube.com/embed/Z-3NJBxkudc"
                title="YouTube video player"
                frameBorder="0"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
              ></iframe>
            </div>
          </div>
        </div>
      </div>
      <div className="parallax parallax-2">
        <div className="parallax-content">
          <h2>Get your custom fertility assistant</h2>
          <p>Register for our Beta app</p>
          <RegisterInterestForm />
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;